// @owners { team: patients }
import { COLORS } from '@alto/design-library-tokens';

export const getDisabledColor = (loading: boolean) =>
  loading ? COLORS.TEXT_COLORS.DISABLED : COLORS.TEXT_COLORS.PRIMARY;
